import React from 'react';
import { Container } from '@mui/material';
import { Routes, Route, useLocation } from 'react-router-dom';
import DatePicker from '../components/DatePicker/DatePicker';
import Header from '../components/Header';
import Profile from '../components/Profile';
import Booking from '../components/features/Bookings/Bookings';
import Trainings from '../components/trainings/Trainings';
import BottomNavi from '../components/BottomNavi';
import Policy from '../components/Policy';
import Privacy from '../components/Privacy';
import PlacePicker from '../components/features/PlacePicker/PlacePicker';
import SharedDoor from '../components/SharedDoor';
import PlacePickerReroute from '../components/PlacePickerReroute';
import AdminPanelPage from '../pages/admin-panel/AdminPanelPage';
import VersionUpdateButton from '../components/VersionUpdateButton';

const AppInner = () => {
  const location = useLocation();
  const adminLocation = location.pathname === '/admin-panel';
  return (
    <>
      <Header />
      <PlacePickerReroute />
      <Container maxWidth={adminLocation ? undefined : 'sm'}>
        <Routes>
          <Route
            path='/booking'
            element={<DatePicker />}
          />
          <Route
            path='/trainings'
            element={<Trainings />}
          />
          <Route
            path='/books'
            element={<Booking />}
          />
          <Route
            path='/profile'
            element={<Profile />}
          />
          <Route
            path='/privacy-policy'
            element={<Privacy />}
          />
          <Route
            path='/club-policy'
            element={<Policy />}
          />
          <Route
            path='/shared/:pwd'
            element={<SharedDoor />}
          />
          <Route
            path='/admin-panel'
            element={<AdminPanelPage />}
          />
          <Route
            path='/pick-place'
            element={<PlacePicker />}
          />
        </Routes>
        <div>
          <VersionUpdateButton />
        </div>
      </Container>
      <BottomNavi />
    </>
  );
};

export default AppInner;
